import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getPageContent, upsertPageContentBlock } from '@/lib/api/pages';

export function usePageContent(pageSlug: string) {
  return useQuery({
    queryKey: ['page_content', pageSlug],
    queryFn: () => getPageContent(pageSlug),
    staleTime: 1000 * 60 * 5,
  });
}

export function useSavePageBlock(pageSlug: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      blockKey,
      content,
      updatedBy,
    }: {
      blockKey: string;
      content: Record<string, unknown>;
      updatedBy: string;
    }) => upsertPageContentBlock(pageSlug, blockKey, content, updatedBy),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['page_content', pageSlug] });
    },
  });
}
